<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view :lang="lang" @lang-change="setLang"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      lang: 'CN'
    }
  },
  created () {
    const saved = localStorage.getItem('lang')
    if (saved) this.lang = saved
  },
  methods: {
    setLang (code) {
      this.lang = code
      localStorage.setItem('lang', code)
    }
  }
}
</script>

<style lang="scss">
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>